<script>
export default {
  name: 'PageNavigationButton',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>

<template>
  <button
    class="cxm-PageNavigationButton"
    :class="{'-active': active }"
    v-on="$listeners"
  >
    <slot>
      {{ label }}
    </slot>
  </button>
</template>

<style lang="scss" scoped>
.cxm-PageNavigationButton {
  align-items: center;
  appearance: none;
  background-color: var(--track-color-white);
  border-radius: 32px;
  border: 0;
  color: var(--track-color-bluegray-60);
  cursor: pointer;
  display: flex;
  font-size: var(--track-font-size-xs);
  font-weight: var(--track-font-weight-regular);
  height: 32px;
  justify-content: center;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  width: 32px;

  &.-active,
  &:hover {
    background-color: var(--track-color-bluegray-10);
    color: var(--track-color-bluegray-80);
  }

  &.-active {
    font-weight: var(--track-font-weight-semibold);
  }
}
</style>
